<app-shared-navbar
  [brandRoute]="'/'"
  [siteName]="currentsitename"
  [showSiteName]="showPrimaryMenus"
  [menuItems]="menuItems"
  [profileMenuItems]="profileMenuItems"
  [avatarSrc]="avatarSrc"
  [showNotifications]="notificationConfig.show"
  [notificationPermission]="notificationConfig.permission"
  (itemSelected)="onNavbarAction($event)">
</app-shared-navbar>

